import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20product%20photography%20flat%20lay%20with%20fashion%20items%20accessories%20shoes%20and%20clothing%20on%20warm%20cream%20beige%20background%2C%20natural%20daylight%2C%20clean%20aesthetic%20editorial%20style%2C%20gentle%20warm%20tones%2C%20elegant%20minimal%20composition%2C%20scattered%20arrangement%20of%20trendy%20items%2C%20soft%20shadows%2C%20high%20resolution%20lifestyle%20product%20photography&width=1800&height=1200&seq=hero-bg-main-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white/85 backdrop-blur-sm rounded-2xl p-8 md:p-12 text-center">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              {t('hero.title_line1')}
              <br />
              <span className="text-foreground-700 font-normal text-3xl md:text-4xl lg:text-5xl">
                {t('hero.title_line2')}
              </span>
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 max-w-lg mx-auto">
              {t('hero.subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>{t('hero.cta_primary')}</span>
                <div className="w-6 h-6 rounded-full border-2 border-background-50 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-8 py-4 border-2 border-foreground-800 text-foreground-800 font-semibold text-sm rounded-lg hover:bg-foreground-800 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_secondary')}
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((cat) => (
                <a
                  key={cat.key}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-4 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-600 text-xs font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all whitespace-nowrap cursor-pointer"
                >
                  {t(cat.nameKey)}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}